/* ═══════════════════════════════════════════════════════════
   MADAKE PERSONALIZER — Storefront JavaScript
   ============================================================
   Reads template config from data-* attributes (server-rendered
   by Liquid), handles all UI interactions, adds to Shopify cart.
═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';
  let _activeMadakeInstance = null;

  // ──────────────────────────────────────────────────────────
  // INITIALIZATION — runs once per page
  // ──────────────────────────────────────────────────────────

  // Initialize personalizer instances (creates modal controllers, doesn't bind clicks)
  document.addEventListener('DOMContentLoaded', initAllPersonalizers);
  document.addEventListener('shopify:section:load', initAllPersonalizers);
  // If the DOM is already ready (script loaded late), defer init until after
  // the class definition below is parsed.
  if (document.readyState !== 'loading') {
    setTimeout(initAllPersonalizers, 0);
  }

  function initAllPersonalizers() {
    const buttons = document.querySelectorAll('[data-madake-open]');
    buttons.forEach(initButton);
  }

  function initButton(btn) {
    if (btn.dataset.madakeInitialized === 'true') return;
    btn.dataset.madakeInitialized = 'true';

    const modalId = btn.dataset.madakeOpen;
    const modal = document.getElementById(modalId);
    if (!modal) {
      console.warn('[Madake] Modal not found:', modalId);
      return;
    }

    // Create the controller and stash it on the button for later
    btn._madakeInstance = new MadakePersonalizer(modal, btn);
  }

  // ONE global click listener handles all personalize buttons via delegation.
  // This is immune to timing/binding/sandbox issues.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-madake-open]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Make sure the instance exists (init it on-demand if needed)
    if (!btn._madakeInstance) {
      initButton(btn);
    }
    if (btn._madakeInstance) {
      btn._madakeInstance.open();
    } else {
      console.warn('[Madake] Could not open modal — no instance');
    }
  }, true); // useCapture=true so we catch the click before theme JS does

  // ──────────────────────────────────────────────────────────
  // MAIN PERSONALIZER CLASS
  // ──────────────────────────────────────────────────────────

  class MadakePersonalizer {
    constructor(modal, btn) {
      this.modal = modal;
      this.btn = btn;

      // Read template config from data-* attributes (set by Liquid)
      this.templateId = modal.dataset.templateId;
      this.productId = modal.dataset.productId;
      this.maxChars = parseInt(modal.dataset.maxChars, 10) || 14;
      this.textSize = parseInt(modal.dataset.textSize, 10) || 28;
      this.emojiSizeRatio = parseFloat(modal.dataset.emojiSizeRatio) || 1.2;
      this.baseCharge = parseInt(modal.dataset.baseCharge, 10) || 0;
      this.posX = parseFloat(modal.dataset.posX) || 50;
      this.posY = parseFloat(modal.dataset.posY) || 70;
      this.fallbackImage = modal.dataset.fallbackImage || '';
      this.personalizationProductId = modal.dataset.personalizationProductId || null;
      this.personalizationVariantId = modal.dataset.personalizationVariantId || null;

      // Parse preview images JSON (per-product preview image override)
     this.previewImages = {};
try {
  const raw = modal.dataset.previewImages;
  if (raw && raw !== 'null' && raw !== '') {
    let parsed = JSON.parse(raw.replace(/&quot;/g, '"'));
    // If the metaobject field is text type, it comes through as a JSON string —
    // parse it once more to get the actual object.
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    if (parsed && typeof parsed === 'object') {
      this.previewImages = parsed;
    }
  }
} catch (e) {
  console.warn('[Madake] Could not parse preview images:', e);
  this.previewImages = {};
}

      // Current customer selection state
      this.state = {
        name: '',
        fontId: null,
        colorId: null,
        emojis: [],   // [{ id, position: 'start' | 'end' }]
        remarks: '',
      };

      this.cacheElements();
      this.applyPreviewImage();
      this.applyEmbroideryPosition();
      this.bindEvents();
      this.preselectDefaults();
      this.updatePreview();
    }

    cacheElements() {
      const m = this.modal;
      this.el = {
        overlay: m,
        closeBtn: m.querySelector('[data-mp-close]'),
        bg: m.querySelector('[data-mp-bg]'),
        overlayEmb: m.querySelector('[data-mp-overlay]'),
        hint: m.querySelector('[data-mp-hint]'),
        nameInput: m.querySelector('[data-mp-name]'),
        charCount: m.querySelector('[data-mp-char-count]'),
        fontGrid: m.querySelector('[data-mp-font-grid]'),
        colorGrid: m.querySelector('[data-mp-color-grid]'),
        emojiGrid: m.querySelector('[data-mp-emoji-grid]'),
        selectedSection: m.querySelector('[data-mp-selected-section]'),
        selectedList: m.querySelector('[data-mp-selected-list]'),
        remarks: m.querySelector('[data-mp-remarks]'),
        extra: m.querySelector('[data-mp-extra]'),
        breakdown: m.querySelector('[data-mp-breakdown]'),
        saveBtn: m.querySelector('[data-mp-save]'),
      };

      // Find sibling summary block (lives next to the button, not in modal)
      const btnWrap = this.btn.closest('[data-madake-button-wrap]');
      if (btnWrap) {
        this.el.summary = btnWrap.querySelector('[data-madake-summary]');
        this.el.summaryName = btnWrap.querySelector('[data-madake-summary-name]');
        this.el.summaryFont = btnWrap.querySelector('[data-madake-summary-font]');
        this.el.summaryColor = btnWrap.querySelector('[data-madake-summary-color]');
        this.el.summaryEmojis = btnWrap.querySelector('[data-madake-summary-emojis]');
        this.el.summaryExtra = btnWrap.querySelector('[data-madake-summary-extra]');
        this.el.btnText = btnWrap.querySelector('[data-madake-btn-text]');
      }

      this.el.toast = document.querySelector('[data-madake-toast]');
    }

    applyPreviewImage() {
  const map = this.previewImages || {};
  const gid = `gid://shopify/Product/${this.productId}`;
  const img = map[this.productId] || map[gid] || this.fallbackImage;
  
  console.log('[Madake] applyPreviewImage', {
    productId: this.productId,
    triedGid: gid,
    mapKeyCount: Object.keys(map).length,
    firstKey: Object.keys(map)[0] || '(empty map)',
    matched: !!img,
    img: img
  });
  
  if (img && this.el.bg) {
    this.el.bg.style.backgroundImage = `url("${img}")`;
  }
}
    
    applyEmbroideryPosition() {
      if (!this.el.overlayEmb) return;
      this.el.overlayEmb.style.left = this.posX + '%';
      this.el.overlayEmb.style.top = this.posY + '%';
      // Font size is applied responsively via applyResponsiveFontSize()
      // which reads the active font's own size and scales to canvas width.
      this.applyResponsiveFontSize();
      // Watch canvas resize (orientation change, window resize) and re-scale.
      if (!this._resizeObserver) {
        this._resizeObserver = new ResizeObserver(() => this.applyResponsiveFontSize());
        const wrap = this.modal.querySelector('.madake-preview-canvas-wrap');
        if (wrap) this._resizeObserver.observe(wrap);
      }
    }

    // Scales font size so it always looks proportional to the preview canvas.
    // Base reference: 28px on a 560px-wide canvas (the desktop modal at ~70vw).
    // Any font can override the base size via data-mp-font-size on its tile.
    applyResponsiveFontSize() {
      if (!this.el.overlayEmb) return;
      const wrap = this.modal.querySelector('.madake-preview-canvas-wrap');
      if (!wrap) return;
      const canvasWidth = wrap.clientWidth;
      if (!canvasWidth) return;

      // Get active font's preferred size (falls back to template-level textSize)
      const activeFontEl = this.el.fontGrid?.querySelector('.madake-font-option.selected');
      const baseFontSize = activeFontEl
        ? (parseInt(activeFontEl.dataset.mpFontSize, 10) || this.textSize)
        : this.textSize;

      // Reference canvas width this base size was designed for
      const referenceWidth = 560;
      const scaled = Math.round(baseFontSize * (canvasWidth / referenceWidth));
      // Clamp: never smaller than 10px, never larger than baseFontSize * 2
      const clamped = Math.max(10, Math.min(scaled, baseFontSize * 2));
      this.el.overlayEmb.style.fontSize = clamped + 'px';
    }

    preselectDefaults() {
      // First font and first color selected by default
      const firstFont = this.el.fontGrid?.querySelector('.madake-font-option');
      if (firstFont) {
        firstFont.classList.add('selected');
        this.state.fontId = firstFont.dataset.mpFontId;
        this.applyFontToOverlay(firstFont);
      }
      const firstColor = this.el.colorGrid?.querySelector('.madake-color-swatch');
      if (firstColor) {
        firstColor.classList.add('selected');
        this.state.colorId = firstColor.dataset.mpColorId;
        this.el.overlayEmb.style.color = firstColor.dataset.mpColorHex;
      }
    }

    bindEvents() {
      // Close handlers
      this.el.closeBtn?.addEventListener('click', () => this.close());
      this.el.overlay.addEventListener('click', (e) => {
        if (e.target === this.el.overlay) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.el.overlay.classList.contains('open')) this.close();
      });

      // Name input
      this.el.nameInput?.addEventListener('input', (e) => this.onNameInput(e));

      // Font selection
      this.el.fontGrid?.querySelectorAll('.madake-font-option').forEach(opt => {
        opt.addEventListener('click', () => this.selectFont(opt));
      });

      // Color selection
      this.el.colorGrid?.querySelectorAll('.madake-color-swatch').forEach(sw => {
        sw.addEventListener('click', () => this.selectColor(sw));
      });

      // Emoji selection
      this.el.emojiGrid?.querySelectorAll('.madake-emoji-tile').forEach(tile => {
        tile.addEventListener('click', () => this.toggleEmoji(tile));
      });

      // Remarks
      this.el.remarks?.addEventListener('input', (e) => {
        this.state.remarks = e.target.value;
      });

      // Save
      this.el.saveBtn?.addEventListener('click', () => this.save());
    }

    // ────────────────────────────────────────────────────────
    // OPEN / CLOSE
    // ────────────────────────────────────────────────────────

    open() {
  _activeMadakeInstance = this;
  document.body.classList.add('madake-modal-open');
  if (this.btn.dataset.towelProductId) {
    this.productId = this.btn.dataset.towelProductId;
    this.applyPreviewImage();
  }
  this.renderDOMFromState();
  this.el.overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  
  // Reset scroll so user sees the preview + name input first
  const modalContent = this.el.overlay.querySelector('.madake-modal');
  if (modalContent) modalContent.scrollTop = 0;
}

    renderDOMFromState() {
  // Sync modal DOM to this instance's state.
  // Needed because multiple buttons (e.g. set slots) share one modal —
  // when slot 2's button opens it, the DOM must show slot 2's state, not slot 1's.
  if (this.el.nameInput) {
    this.el.nameInput.value = this.state.name || '';
    if (this.el.charCount) {
      const len = (this.state.name || '').length;
      this.el.charCount.textContent = `${len} / ${this.maxChars}`;
      this.el.charCount.classList.toggle('warn', len >= this.maxChars - 1);
    }
  }
  this.el.fontGrid?.querySelectorAll('.madake-font-option').forEach(o => o.classList.remove('selected'));
  if (this.state.fontId) {
    const fontEl = this.el.fontGrid?.querySelector(`.madake-font-option[data-mp-font-id="${this.state.fontId}"]`);
    if (fontEl) {
      fontEl.classList.add('selected');
      this.applyFontToOverlay(fontEl);
    }
  }
  this.el.colorGrid?.querySelectorAll('.madake-color-swatch').forEach(s => s.classList.remove('selected'));
  if (this.state.colorId) {
    const colorEl = this.el.colorGrid?.querySelector(`.madake-color-swatch[data-mp-color-id="${this.state.colorId}"]`);
    if (colorEl) {
      colorEl.classList.add('selected');
      if (this.el.overlayEmb) this.el.overlayEmb.style.color = colorEl.dataset.mpColorHex;
    }
  }
  this.el.emojiGrid?.querySelectorAll('.madake-emoji-tile').forEach(t => {
    t.classList.remove('selected');
    t.classList.remove('madake-emoji-disabled');
  });
  this.state.emojis.forEach(s => {
    const tile = this.el.emojiGrid?.querySelector(`[data-mp-emoji-id="${s.id}"]`);
    if (tile) tile.classList.add('selected');
  });
  if (this.state.emojis.length >= 2) {
    this.el.emojiGrid?.querySelectorAll('.madake-emoji-tile:not(.selected)').forEach(t => {
      t.classList.add('madake-emoji-disabled');
    });
  }
  this.renderSelectedEmojis();
  if (this.el.remarks) this.el.remarks.value = this.state.remarks || '';
  this.updatePreview();
  this.updateBreakdown();
}


    close() {
      this.el.overlay.classList.remove('open');
      document.body.style.overflow = '';
      document.body.classList.remove('madake-modal-open');
    }

    // ────────────────────────────────────────────────────────
    // NAME INPUT — with sanitization
    // ────────────────────────────────────────────────────────

    onNameInput(e) {
      let v = e.target.value;
      // Block emojis from name field (they have their own picker)
      v = v.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{1F000}-\u{1F02F}]/gu, '');
      e.target.value = v;
      this.state.name = v;
      if (this.el.charCount) {
        this.el.charCount.textContent = `${v.length} / ${this.maxChars}`;
        this.el.charCount.classList.toggle('warn', v.length >= this.maxChars - 1);
      }
      this.updatePreview();
      this.updateBreakdown();
    }

    // ────────────────────────────────────────────────────────
    // FONT / COLOR / EMOJI SELECTION
    // ────────────────────────────────────────────────────────

    selectFont(opt) {
      this.el.fontGrid.querySelectorAll('.madake-font-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      this.state.fontId = opt.dataset.mpFontId;
      this.applyFontToOverlay(opt);
      this.updatePreview();
    }

    applyFontToOverlay(opt) {
      const fontId = opt.dataset.mpFontId;
      const cssFamily = opt.dataset.mpCssFamily || 'serif';
      if (this.el.overlayEmb) {
        this.el.overlayEmb.style.fontFamily = `'mp-${fontId}', ${cssFamily}`;
      }
      // Re-scale to this font's preferred size
      this.applyResponsiveFontSize();
    }

    selectColor(sw) {
      this.el.colorGrid.querySelectorAll('.madake-color-swatch').forEach(s => s.classList.remove('selected'));
      sw.classList.add('selected');
      this.state.colorId = sw.dataset.mpColorId;
      if (this.el.overlayEmb) {
        this.el.overlayEmb.style.color = sw.dataset.mpColorHex;
      }
    }

    toggleEmoji(tile) {
      const id = tile.dataset.mpEmojiId;
      const idx = this.state.emojis.findIndex(s => s.id === id);
      if (idx >= 0) {
        this.state.emojis.splice(idx, 1);
        tile.classList.remove('selected');
      } else if (this.state.emojis.length < 2) {
        this.state.emojis.push({ id, position: 'end' });
        tile.classList.add('selected');
      } else {
        return; // Already 2 selected, do nothing
      }
      // Update disabled state on all tiles
      const allTiles = this.el.emojiGrid.querySelectorAll('.madake-emoji-tile');
      allTiles.forEach(t => {
        if (!t.classList.contains('selected')) {
          t.classList.toggle('madake-emoji-disabled', this.state.emojis.length >= 2);
        }
      });
      this.renderSelectedEmojis();
      this.updatePreview();
      this.updateBreakdown();
    }

    renderSelectedEmojis() {
      const section = this.el.selectedSection;
      const list = this.el.selectedList;
      if (!section || !list) return;
      if (this.state.emojis.length === 0) {
        section.style.display = 'none';
        return;
      }
      section.style.display = '';

      list.innerHTML = this.state.emojis.map((s, i) => {
        const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
        if (!tile) return '';
        const name = tile.dataset.mpEmojiName;
        const img = tile.dataset.mpEmojiImage;
        const char = tile.dataset.mpEmojiChar;
        const price = tile.dataset.mpEmojiPrice;
        const currency = tile.dataset.mpEmojiCurrency || '₹';
        const visual = img
          ? `<img src="${escapeAttr(img)}" alt="" width="24" height="24">`
          : escapeHtml(char);

        return `
          <div class="madake-selected-emoji-row" draggable="true" data-mp-row-index="${i}">
            <div class="madake-drag-handle">⠿</div>
            <div class="mp-emo-char">${visual}</div>
            <div class="mp-emo-info">
              ${escapeHtml(name)}
              <div class="mp-emo-price">+${escapeHtml(currency)}${escapeHtml(price)}</div>
            </div>
            <select data-mp-pos-select="${i}">
              <option value="start" ${s.position === 'start' ? 'selected' : ''}>Before name</option>
              <option value="end" ${s.position === 'end' ? 'selected' : ''}>After name</option>
            </select>
            <div class="madake-reorder-btns">
              <button type="button" data-mp-move="${i}" data-mp-delta="-1" ${i === 0 ? 'disabled' : ''}>▲</button>
              <button type="button" data-mp-move="${i}" data-mp-delta="1" ${i === this.state.emojis.length - 1 ? 'disabled' : ''}>▼</button>
            </div>
            <button type="button" class="mp-remove-emo" data-mp-remove="${s.id}">✕</button>
          </div>
        `;
      }).join('');

      // Bind events on freshly rendered rows
      list.querySelectorAll('[data-mp-pos-select]').forEach(sel => {
        sel.addEventListener('change', (e) => {
          const i = parseInt(e.target.dataset.mpPosSelect, 10);
          this.state.emojis[i].position = e.target.value;
          this.updatePreview();
        });
      });
      list.querySelectorAll('[data-mp-move]').forEach(btn => {
        btn.addEventListener('click', () => {
          const i = parseInt(btn.dataset.mpMove, 10);
          const delta = parseInt(btn.dataset.mpDelta, 10);
          this.moveEmoji(i, delta);
        });
      });
      list.querySelectorAll('[data-mp-remove]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.mpRemove;
          const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${id}"]`);
          if (tile) this.toggleEmoji(tile);
        });
      });
      this.bindDragHandlers();
    }

    moveEmoji(i, delta) {
      const newIdx = i + delta;
      if (newIdx < 0 || newIdx >= this.state.emojis.length) return;
      const [item] = this.state.emojis.splice(i, 1);
      this.state.emojis.splice(newIdx, 0, item);
      this.renderSelectedEmojis();
      this.updatePreview();
    }

    bindDragHandlers() {
      let dragSrcIdx = null;
      this.el.selectedList.querySelectorAll('.madake-selected-emoji-row').forEach(row => {
        row.addEventListener('dragstart', (e) => {
          dragSrcIdx = parseInt(row.dataset.mpRowIndex, 10);
          row.classList.add('dragging');
          e.dataTransfer.effectAllowed = 'move';
        });
        row.addEventListener('dragover', (e) => {
          e.preventDefault();
          row.classList.add('drag-over');
        });
        row.addEventListener('dragleave', () => row.classList.remove('drag-over'));
        row.addEventListener('drop', (e) => {
          e.preventDefault();
          row.classList.remove('drag-over');
          const targetIdx = parseInt(row.dataset.mpRowIndex, 10);
          if (dragSrcIdx === null || dragSrcIdx === targetIdx) return;
          const [item] = this.state.emojis.splice(dragSrcIdx, 1);
          this.state.emojis.splice(targetIdx, 0, item);
          this.renderSelectedEmojis();
          this.updatePreview();
        });
        row.addEventListener('dragend', () => {
          row.classList.remove('dragging');
          this.el.selectedList.querySelectorAll('.madake-selected-emoji-row').forEach(r => r.classList.remove('drag-over'));
          dragSrcIdx = null;
        });
      });
    }

    // ────────────────────────────────────────────────────────
    // PREVIEW UPDATE — live re-render of embroidery overlay
    // ────────────────────────────────────────────────────────

    updatePreview() {
      const overlay = this.el.overlayEmb;
      const hint = this.el.hint;
      if (!overlay) return;
      const hasContent = this.state.name.trim() || this.state.emojis.length > 0;
      if (hint) hint.style.display = hasContent ? 'none' : '';
      if (!hasContent) {
        overlay.innerHTML = '';
        return;
      }

      const startEmojis = this.state.emojis.filter(s => s.position === 'start');
      const endEmojis = this.state.emojis.filter(s => s.position === 'end');

      const renderEmojis = (arr) => arr.map(s => {
        const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
        if (!tile) return '';
        const img = tile.dataset.mpEmojiImage;
        const char = tile.dataset.mpEmojiChar;
        const sizeMult = (parseFloat(tile.dataset.mpEmojiSize) || 1.0) * this.emojiSizeRatio;
        if (img) {
          return `<span class="mp-emoji" style="font-size:${sizeMult}em;"><img src="${escapeAttr(img)}" alt="" style="height:${sizeMult}em;width:auto;vertical-align:middle;"></span>`;
        }
        return `<span class="mp-emoji" style="font-size:${sizeMult}em;">${escapeHtml(char)}</span>`;
      }).join('');

      const nameHtml = this.state.name ? `<span>${escapeHtml(this.state.name)}</span>` : '';
      overlay.innerHTML = renderEmojis(startEmojis) + nameHtml + renderEmojis(endEmojis);
      
      // Auto-fit: shrink the overlay if it overflows the towel canvas
      this.fitOverlay();
    }

     fitOverlay() {
      const overlay = this.el.overlayEmb;
      const wrap = this.modal.querySelector('.madake-preview-canvas-wrap');
      if (!overlay || !wrap) return;
      // Reset any previous scale before measuring
      overlay.style.transform = 'translate(-50%, -50%) scale(1)';
      // Use requestAnimationFrame so the browser has applied the new innerHTML
      requestAnimationFrame(() => {
        const wrapWidth = wrap.clientWidth;
        const overlayWidth = overlay.scrollWidth;
        // Leave 10% padding on each side so content doesn't touch the towel edges
        const maxWidth = wrapWidth * 0.8;
        if (overlayWidth > maxWidth) {
          const scale = maxWidth / overlayWidth;
          overlay.style.transform = `translate(-50%, -50%) scale(${scale})`;
        }
      });
    }

    // ────────────────────────────────────────────────────────
    // PRICING
    // ────────────────────────────────────────────────────────

    currentExtra() {
      let total = 0;
      if (this.state.name.trim()) total += this.baseCharge;
      this.state.emojis.forEach(s => {
        const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
        if (tile) total += parseInt(tile.dataset.mpEmojiPrice, 10) || 0;
      });
      return total;
    }

    updateBreakdown() {
      const parts = [];
      if (this.state.name.trim() && this.baseCharge) {
        parts.push(`Name: ₹${this.baseCharge}`);
      }
      this.state.emojis.forEach(s => {
        const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
        if (tile) {
          const name = tile.dataset.mpEmojiName;
          const price = tile.dataset.mpEmojiPrice;
          const currency = tile.dataset.mpEmojiCurrency || '₹';
          parts.push(`${name}: ${currency}${price}`);
        }
      });
      if (this.el.breakdown) this.el.breakdown.textContent = parts.join(' · ');
      if (this.el.extra) this.el.extra.textContent = this.currentExtra();
    }

    // ────────────────────────────────────────────────────────
    // SAVE → Add personalization items to Shopify cart
    // ────────────────────────────────────────────────────────

    async save() {
  if (!this.state.name.trim() && this.state.emojis.length === 0) {
    alert('Please enter a name or pick at least one emoji.');
    return;
  }

  const fontEl = this.el.fontGrid.querySelector('.madake-font-option.selected');
  const colorEl = this.el.colorGrid.querySelector('.madake-color-swatch.selected');
  const fontName = fontEl ? (fontEl.querySelector('.mp-font-name')?.textContent || '') : '';
  const colorName = colorEl ? (colorEl.dataset.name || '') : '';

  const emojiSummary = this.state.emojis.map(s => {
    const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
    if (!tile) return '';
    const name = tile.dataset.mpEmojiName;
    const char = tile.dataset.mpEmojiChar || '';
    return `${char} ${name} (${s.position === 'start' ? 'before' : 'after'})`.trim();
  }).join(', ');

  // Update summary block next to the button
  if (this.el.summary) {
    this.el.summaryName.textContent = this.state.name || '(emoji only)';
    this.el.summaryFont.textContent = fontName || '—';
    this.el.summaryColor.textContent = colorName || '—';
    this.el.summaryEmojis.textContent = emojiSummary || 'None';
    this.el.summaryExtra.textContent = this.currentExtra();
    this.el.summary.classList.add('show');
  }
  if (this.el.btnText) this.el.btnText.textContent = '✓ Edit Personalization';
  this.btn.classList.add('has-personalization');

  // Store properties on the button (used by single-product cart flow)
  this.btn.madakePersonalization = this.buildCartProperties(fontName, colorName, emojiSummary);

  // ─── Branch: SET context vs SINGLE context ───
  if (this.btn.dataset.madakeSetContext === 'true') {
    // Set context — set-bundle handles cart adds, we just store state and notify
    const fullState = {
      name: this.state.name,
      fontName,
      colorName,
      emojis: this.state.emojis.map(s => {
        const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${s.id}"]`);
        return {
          id: s.id,
          position: s.position,
          variantId: tile?.dataset.mpEmojiVariantId || null,
          name: tile?.dataset.mpEmojiName || '',
          char: tile?.dataset.mpEmojiChar || ''
        };
      }),
      remarks: this.state.remarks
    };
    this.btn.madakeFullState = fullState;
    const slot = parseInt(this.btn.dataset.slot, 10);
    document.dispatchEvent(new CustomEvent('madake:set-slot-saved', {
      detail: { slot, fullState },
      bubbles: true
    }));
    this.close();
    this.showToast('Saved for towel ' + slot);
    return;
  }

  // Single product — existing behaviour: attach properties to ATC form and intercept click
  this.attachToCartForm();
  this.close();
  this.showToast('Personalization saved');
}

    buildCartProperties(fontName, colorName, emojiSummary) {
      return {
        'Personalization Name': this.state.name || '(emoji only)',
        'Font': fontName,
        'Thread Color': colorName,
        'Emojis': emojiSummary || 'None',
        'Special Remarks': this.state.remarks || '',
      };
    }

    attachToCartForm() {
      // Find the REAL Add to Cart button — there are multiple forms on this page,
      // but only one has a visible Add to Cart button (button[name="add"]).
      // We find the button first, then walk up to its form.
      const addBtn = document.querySelector('button[name="add"].add-to-cart-button')
                  || document.querySelector('button[name="add"]');
      if (!addBtn) {
        console.warn('[Madake] No Add to Cart button found on page');
        return;
      }

      const form = addBtn.closest('form[action*="/cart/add"]');
      if (!form) {
        console.warn('[Madake] Add to Cart button is not inside a cart form');
        return;
      }

      // Remove any existing Madake hidden inputs (re-save scenario)
      form.querySelectorAll('input[data-madake-prop]').forEach(el => el.remove());

      // Add line item properties as hidden inputs (these go with the parent towel)
      const props = this.btn.madakePersonalization;
      Object.entries(props).forEach(([key, value]) => {
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        input.dataset.madakeProp = '1';
        form.appendChild(input);
      });

      // Hook the Add to Cart button via capture-phase click listener.
      // This intercepts BEFORE Dwell's own click handler runs.
      if (!addBtn.dataset.madakeClickHooked) {
        addBtn.dataset.madakeClickHooked = '1';
        addBtn.addEventListener('click', (e) => this.onAddToCartClick(e, form), true);
      }
    }

    async onAddToCartClick(e, form) {
      const stored = this.btn.madakePersonalization;
      if (!stored) return; // no personalization saved, let Dwell handle normally

      // Block Dwell's handler — we take over the cart-add flow
      e.preventDefault();
      e.stopImmediatePropagation();

      try {
        // 1. Add the parent towel (with line item properties via FormData)
        const formData = new FormData(form);
        const towelResp = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });
        if (!towelResp.ok) throw new Error('Towel add failed');

        // 2. Add the personalization service product (if name typed + variant set)
        if (this.state.name.trim() && this.personalizationVariantId) {
          await this.addLinkedToCart(this.personalizationVariantId, {
            '_linked_to': this.productId,
            'For': stored['Personalization Name'],
          });
        }

        // 3. Add each emoji variant as a separate line item
        for (const sel of this.state.emojis) {
          const tile = this.el.emojiGrid.querySelector(`[data-mp-emoji-id="${sel.id}"]`);
          const variantId = tile?.dataset.mpEmojiVariantId;
          if (variantId) {
            await this.addLinkedToCart(variantId, {
              '_linked_to': this.productId,
              'Position': sel.position,
            });
          }
        }

        // 4. Navigate to cart page (matches default Shopify behavior)
        window.location.href = '/cart';
      } catch (err) {
        console.error('[Madake] Cart add failed:', err);
        alert('Something went wrong adding your personalization. Please try again.');
      }
    }


    async addLinkedToCart(variantId, properties) {
      const body = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: properties,
        }],
      };
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (!resp.ok) {
        console.warn('[Madake] Linked item add failed:', variantId);
      }
    }

    // ────────────────────────────────────────────────────────
    // TOAST
    // ────────────────────────────────────────────────────────

    showToast(msg) {
      if (!this.el.toast) return;
      this.el.toast.textContent = msg;
      this.el.toast.classList.add('show');
      setTimeout(() => this.el.toast.classList.remove('show'), 2200);
    }
  }

  // Guard: when multiple personalizer instances exist (e.g. set product with N slot buttons),
  // only the most-recently-opened instance handles modal interactions. Without this, every
  // instance's handlers fire on every click and personalization bleeds across slots.
  ['onNameInput', 'selectFont', 'selectColor', 'toggleEmoji', 'save'].forEach(function (methodName) {
    const original = MadakePersonalizer.prototype[methodName];
    MadakePersonalizer.prototype[methodName] = function (...args) {
      if (_activeMadakeInstance !== this) return;
      return original.apply(this, args);
    };
  });

  // ──────────────────────────────────────────────────────────
  // UTILITIES
  // ──────────────────────────────────────────────────────────

  // ──────────────────────────────────────────────────────────
  // UTILITIES
  // ──────────────────────────────────────────────────────────

  function escapeHtml(s) {
    if (s === null || s === undefined) return '';
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  function escapeAttr(s) {
    if (s === null || s === undefined) return '';
    return String(s).replace(/"/g, '&quot;');
  }
})();